import React, { VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import { useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

interface Props {
  isShow: boolean;
  expanded: boolean;
  onClick: () => void;
}
const MoreSeeButton: VFC<Props> = ({ isShow, expanded, onClick }: Props) => {
  const theme = useTheme();
  if (!isShow) return null;

  return (
    <Wrapper theme={theme}>
      <Button onClick={onClick}>
        {expanded ? (
          <>
            <KeyboardArrowUpIcon />
            {T.translate('close')}
          </>
        ) : (
          <>
            <KeyboardArrowDownIcon />
            {T.translate('moreSee')}
          </>
        )}
      </Button>
    </Wrapper>
  );
};

export default MoreSeeButton;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(1)}px;
`;
